// extracted by css-extract-rspack-plugin
export default {"cls1":"ChurnedUserReactivationButton-cls1_JTc","cls2":"ChurnedUserReactivationButton-cls2_kw7 ChurnedUserReactivationButton-cls1_JTc"};